// extracted by mini-css-extract-plugin
export default {"tag-container":"yzgwi_tag-container","sub-image-tag":"D17ke_sub-image-tag","sub-text-tag":"TK8o__sub-text-tag"};